import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";


export const ExpenseList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // Header
   useEffect(() => {
  updateMainHeader("Sales");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Expense Management": "/expense/list" },
  ]);

  const source = {
    url: "expense/list",  // ✅ Fixed API path
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };

  const columns: IColumns[] = [
    { header: "Date", fieldName: "Date" ,type:"date"},
    { header: "Name", fieldName: "Name" },
    { header: "Total Amount", fieldName: "Amount" },
    { header: "Remarks", fieldName: "Remarks", tooltip: true },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        const expenseId = row.ExpenseId ;
        if (!expenseId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }
        
        if (action === "Edit") {
          navigate(`/expense/${expenseId}`);
        } else if (action === "Delete") {
          setSelectedId(expenseId);
          setPopupOpen(true);
        }
      },
    },
  ];
  
  const handleClick = () => {
    navigate("/expense");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="expenseGrid"
            title="Expense Management"
            headerType="modern"
            columns={columns}
            source={source}
            exportCsv
            rowsPerPageCount={10}
            searchBox={{ fieldName: "Name" }}
            addButton={{ label: "Add New Expense", color: "secondary" }}
            onAddButtonClick={handleClick}
            multiSelect={true}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
        
        <ConfirmationPopup
          type="DELETE"
          apiUrl="expense/delete"  
          id={selectedId}
          confirmMessage="Are you sure you want to delete this expense?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("expenseGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail || "Delete failed", "error");
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
